<div class="container py-md-4">
  <div class="row justify-content-center">
    <div class="col-lg-8 col-md-10">
      <ng-container *ngIf="mdl_User.get('strInstallationStatus')?.value">
        <div class="text-center mt-3">
          <p
            class="badge rounded-pill alert-primary text-dark px-3 py-2"
            style="font-size: 12px"
          >
            وضعیت درخواست شما :

            <span
              class="badge rounded-pill bg-primary text-white px-3 py-2"
              style="font-size: 12px"
            >
              {{ mdl_User.get("strInstallationStatus")?.value }}
            </span>
          </p>
        </div>
      </ng-container>

      <div class="accordion" id="accordionPanelsStayOpenExample">
        <!--  اطلاعات زمان بندی نصب تجهیزات  -->

        <ng-container *ngIf="mdl_User.get('tiInstallationStatus')?.value > 1">
          <div class="accordion-item">
            <h2 class="accordion-header" id="panelsStayOpen-headingOne">
              <button
                [ngClass]="activeAccordion == 1 ? '' : 'collapsed'"
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseOne"
                [attr.aria-expanded]="isOpen(1)"
                aria-controls="panelsStayOpen-collapseOne"
              >
                اطلاعات زمان بندی نصب تجهیزات
              </button>
            </h2>

            <div
              id="panelsStayOpen-collapseOne"
              class="accordion-collapse collapse"
              [class.show]="isOpen(1)"
              aria-labelledby="panelsStayOpen-headingOne"
              data-bs-parent="#accordionPanelsStayOpenExample"
            >
              <div class="accordion-body">
                <div class="card border-0 rounded-4">
                  <div class="card-body px-4 px-md-5 pb-5">
                    <form [formGroup]="mdl_User" class="user-info-form">
                      <!-- تاریخ ثبت و تاریخ اعلامی برای نصب -->

                      <div class="row g-3 mb-2">
                        <div class="col-md-6">
                          <label
                            for="strRegisterDateTime"
                            class="form-label fw-semibold"
                          >
                            تاریخ ثبت
                          </label>

                          <input
                            type="text"
                            class="form-control form-control-lg rounded-3 text-start"
                            dir="ltr"
                            id="strRegisterDateTime"
                            formControlName="strRegisterDateTime"
                          />
                        </div>

                        <div class="col-md-6">
                          <label
                            for="strAnnouncementTime"
                            class="form-label fw-semibold"
                          >
                            تاریخ اعلامی برای نصب
                          </label>

                          <input
                            type="text"
                            class="form-control form-control-lg rounded-3 text-start"
                            dir="ltr"
                            id="strAnnouncementTime"
                            formControlName="strAnnouncementTime"
                          />
                        </div>
                      </div>

                      <!-- نام نصاب و موبایل نصاب -->

                      <div class="row g-3 mb-2">
                        <div class="col-md-6">
                          <label
                            for="strFullName"
                            class="form-label fw-semibold"
                          >
                            نام نصاب
                          </label>

                          <input
                            type="text"
                            class="form-control form-control-lg rounded-3"
                            id="strFullName"
                            formControlName="strFullName"
                          />
                        </div>

                        <div class="col-md-6">
                          <label
                            for="strMobile1"
                            class="form-label fw-semibold"
                          >
                            موبایل نصاب
                          </label>

                          <input
                            type="text"
                            class="form-control form-control-lg rounded-3"
                            id="strMobile1"
                            formControlName="strMobile1"
                          />
                        </div>
                      </div>

                      <!-- تاریخ نصب  -->

                      <div class="row g-3 mb-2">
                        <div class="col-md-6">
                          <label
                            for="strInstallDate"
                            class="form-label fw-semibold"
                          >
                            تاریخ نصب
                          </label>

                          <input
                            type="text"
                            class="form-control form-control-lg rounded-3 text-start"
                            dir="ltr"
                            id="strInstallDate"
                            formControlName="strInstallDate"
                          />
                        </div>
                      </div>

                      <!-- گزارش نصب -->

                      <div class="mb-4">
                        <label
                          for="strInstallerComment"
                          class="form-label fw-semibold"
                        >
                          گزارش نصب
                        </label>

                        <textarea
                          class="form-control form-control-lg rounded-3"
                          id="strInstallerComment"
                          formControlName="strInstallerComment"
                          rows="3"
                        ></textarea>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!--  اطلاعات کاربری -->

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
            <button
              class="accordion-button"
              [ngClass]="activeAccordion == 2 ? '' : 'collapsed'"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseTwo"
              [attr.aria-expanded]="isOpen(2)"
              aria-controls="panelsStayOpen-collapseTwo"
            >
              اطلاعات کاربری
            </button>
          </h2>

          <div
            id="panelsStayOpen-collapseTwo"
            [class.show]="isOpen(2)"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingTwo"
            data-bs-parent="#accordionPanelsStayOpenExample"
          >
            <div class="accordion-body">
              <div class="card border-0 rounded-4">
                <div class="card-body px-4 px-md-5 pb-5">
                  <form [formGroup]="mdl_User" class="user-info-form">
                    <!-- دکمه پرداخت -->

                    <div
                      *ngIf="mdl_Payment.get('iResult')?.value == 0"
                      class="row g-3 mb-2"
                    >
                      <div class="col-12 alert alert-warning" role="alert">
                        <p class="">
                          کاربر گرامی، جهت قرار گیری در نوبت نصب، لازم است هزینه
                          تجهیزات را ابتدا پرداخت کنید.
                        </p>

                        <div class="text-end">
                          <button class="btn btn-warning" (click)="openUrl()">
                            پرداخت
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- نام و نام خانوادگی -->

                    <div class="row g-3 mb-2">
                      <div class="col-md-6">
                        <label for="strName" class="form-label fw-semibold">
                          نام
                        </label>

                        <input
                          type="text"
                          class="form-control form-control-lg rounded-3"
                          id="strName"
                          formControlName="strName"
                          placeholder="نام خود را وارد کنید"
                        />
                      </div>

                      <div class="col-md-6">
                        <label for="strFamily" class="form-label fw-semibold">
                          نام خانوادگی
                        </label>

                        <input
                          type="text"
                          class="form-control form-control-lg rounded-3"
                          id="strFamily"
                          formControlName="strFamily"
                          placeholder="نام خانوادگی خود را وارد کنید"
                        />
                      </div>
                    </div>

                    <!-- آدرس محل نصب -->

                    <div class="mb-4 position-relative">
                      <label for="strAddress" class="form-label fw-semibold">
                        آدرس محل نصب
                      </label>

                      <input
                        type="text"
                        class="form-control form-control-lg rounded-3"
                        id="strAddress"
                        formControlName="strAddress"
                        [placeholder]="addressPlaceHolder"
                      />

                      <ng-container
                        *ngIf="mdl_User.get('tiInstallationStatus')?.value < 3"
                      >
                        <button
                          class="btn btn-warning rounded"
                          (click)="show_Map()"
                        >
                          <i
                            class="fa fa-map-marker fa-lg"
                            aria-hidden="true"
                          ></i>
                        </button>

                        <custom-map
                          *ngIf="openMap"
                          [strValue]="mdl_Map.get('strAddress')?.value"
                          [longLat]="[
                            mdl_Map.get('fLon')?.value,
                            mdl_Map.get('fLat')?.value,
                          ]"
                          [isOpenModal]="true"
                          (mdl_Submit)="submitMap($event)"
                        >
                        </custom-map>
                      </ng-container>
                    </div>

                    <!-- پلاک تانکر -->
                    <div class="mb-4">
                      <div class="vehicle-no-field-wrapper">
                        <app-qasr-plate
                          formControlName="strVehicleNo"
                        ></app-qasr-plate>
                      </div>
                    </div>

                    <!-- شماره مجوز فروش آب / تاریخ ثبت -->

                    <div class="row g-3 mb-2">
                      <div class="col-md-6">
                        <label
                          for="strRegisterDateTime"
                          class="form-label fw-semibold"
                        >
                          تاریخ ثبت
                        </label>

                        <input
                          class="form-control form-control-lg rounded-3 text-start"
                          dir="ltr"
                          id="strRegisterDateTime"
                          formControlName="strRegisterDateTime"
                        />
                      </div>
                    </div>

                    <!-- توضیحات -->

                    <div class="mb-4">
                      <label for="strComment" class="form-label fw-semibold">
                        توضیحات
                      </label>

                      <textarea
                        class="form-control form-control-lg rounded-3"
                        id="strComment"
                        formControlName="strComment"
                        rows="3"
                        placeholder="توضیحات خود را وارد کنید"
                      ></textarea>
                    </div>

                    <!-- دکمه ویرایش -->

                    <ng-container
                      *ngIf="
                        [0, 1, 2].includes(
                          mdl_User.get('tiInstallationStatus')?.value
                        )
                      "
                    >
                      <div class="d-grid gap-2">
                        <button
                          class="btn bg-primary text-white py-2 rounded-3 shadow-sm"
                          (click)="update_Info()"
                        >
                          ویرایش اطلاعات
                        </button>
                        <button
                          *ngIf="
                            mdl_User.get('tiInstallationStatus').value >= 1
                          "
                          type="button"
                          class="btn btn-outline-secondary"
                          (click)="tankerInvoice()"
                        >
                          فاکتور
                        </button>
                      </div>
                    </ng-container>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>

<ng-template #paymentDialogTemplate let-modal>
  <ng-container>
    <div class="modal-header">
      <h2 class="modal-title">در انتظار پرداخت</h2>
    </div>
    <div class="modal-body" *ngIf="preInvoiceDetail">
      <p>{{ preInvoiceDetail.Description }}</p>
      <p class="fw-bold">{{ preInvoiceDetail.Title }}</p>
      <div class="table-responsive">
        <table class="app-table">
          <thead>
            <tr>
              <th class="text-center fw-bold">عنوان</th>
              <th class="text-center fw-bold">توضیحات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of preInvoiceDetail.Items">
              <td>{{ item.Title }}</td>
              <td>{{ item.Description }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="fw-bold">{{ preInvoiceDetail.InsuranceNote }}</p>
    </div>
    <div class="modal-footer d-flex flex-row justify-content-end">
      <button type="button" class="btn btn-success" (click)="paymentProcess()">
        پرداخت
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #tankerInvoiceDialogTemplate let-modal>
  <ng-container>
    <div class="modal-header">
      <h2 class="modal-title">فاکتور</h2>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="dismiss('Cross click')"
      ></button>
    </div>

    <ng-container *ngIf="tankerInvoiceData">
      <div id="payment-receipt" class="modal-body">
        <!-- <p>{{tankerInvoiceData.Description}}</p> -->
        <p class="receipt-title fw-bold">{{ tankerInvoiceData.Title }}</p>
        <div class="table-responsive">
          <table class="app-table">
            <thead>
              <tr>
                <th class="text-center fw-bold">عنوان</th>
                <th class="text-center fw-bold">توضیحات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of tankerInvoiceData.Items">
                <td>{{ item.Title }}</td>
                <td>{{ item.Description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="fw-bold">{{ tankerInvoiceData.InsuranceNote }}</p>
      </div>

      <div class="modal-footer d-flex justify-content-start">
        <button class="btn btn-outline-primary" (click)="saveShot()">
          دانلود فاکتور
        </button>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #tankerLicenseDialogTemplate let-modal>
  <ng-container>
    <div class="modal-header">
      <h2 class="modal-title">تصویر مجوز</h2>
      <button
        type="button"
        class="btn-close m-0"
        aria-label="Close"
        (click)="dismiss('Cross click')"
      ></button>
    </div>

    <div class="modal-body">
      <img
        src="data:image/jpeg;base64,{{ mdl_User.get('strLicenseImage').value }}"
        alt="تصویر مجوز"
      />
    </div>

    <div class="modal-footer d-flex justify-content-start">
      <button class="btn btn-outline-primary" (click)="viewFullScreen()">
        نمایش تمام صفحه
      </button>
    </div>
  </ng-container>
</ng-template>
